export const name = 'clickUI';
export const description = 'Clicks a visible interactable UI element on the page by its elementId (obtained from the listInteractableUI skill).';
export const parameters = {
  elementId: 'The ID/index (e.g. "0", "1") of the element to click, as returned by listInteractableUI.'
};
export const outputTextForUI = 'Elem kattintása';
export const useOnMobile = false;

export function clickUI(args: { elementId: string }) {
  if (!args || args.elementId === undefined || args.elementId === null) {
    throw new Error('A "elementId" paraméter megadása kötelező.');
  }

  const pageContent = document.querySelector('.page-content');
  const appRoot = document.querySelector('.app') || document.querySelector('#root') || document.body;
  const root = pageContent || appRoot;

  if (!root) {
    throw new Error('Nem található a főoldal tartalomtárolója.');
  }

  // Find by data-ai-id
  let target = root.querySelector(`[data-ai-id="${args.elementId}"]`) as HTMLElement;

  // Fallback: search interactables dynamically if IDs were cleared
  if (!target) {
    function isVisible(el: HTMLElement): boolean {
      if (el.offsetWidth === 0 || el.offsetHeight === 0) return false;
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
      return true;
    }

    function isAiSidebar(el: HTMLElement): boolean {
      return !!(
        el.closest('.mantine-Drawer-root') ||
        el.closest('[class*="Drawer"]') ||
        el.closest('.ai-sidebar') ||
        el.id === 'ai-sidebar'
      );
    }

    const allElements = Array.from(root.querySelectorAll('*')) as HTMLElement[];
    const candidates = allElements.filter(el => {
      if (!isVisible(el) || isAiSidebar(el)) return false;

      const tagName = el.tagName.toUpperCase();
      if (tagName === 'BUTTON' || tagName === 'A') return true;

      const role = el.getAttribute('role');
      if (role && ['button', 'link', 'checkbox', 'radio', 'menuitem', 'tab'].includes(role.toLowerCase())) return true;

      const className = el.className;
      if (typeof className === 'string' && (
        className.includes('Button') ||
        className.includes('ActionIcon') ||
        className.includes('UnstyledButton')
      )) return true;

      const style = window.getComputedStyle(el);
      if (style.cursor === 'pointer') return true;

      return false;
    });

    const interactables = candidates.filter(el => {
      let parent = el.parentElement;
      while (parent) {
        if (candidates.includes(parent)) {
          return false;
        }
        parent = parent.parentElement;
      }
      return true;
    });

    target = interactables[Number(args.elementId)];
  }

  if (!target) {
    throw new Error(`Nem található interaktív elem a megadott azonosítóval: ${args.elementId}`);
  }

  // Scroll into view
  target.scrollIntoView({ block: 'center', inline: 'nearest' });

  // Focus if possible
  target.focus();

  // Trigger full click events sequence
  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true
  });
  target.dispatchEvent(clickEvent);

  // Fallback native click
  if (typeof target.click === 'function') {
    target.click();
  }

  const text = target.innerText || target.textContent || '';
  return {
    success: true,
    clickedElement: {
      id: args.elementId,
      text: text.trim().substring(0, 50),
      tagName: target.tagName.toLowerCase()
    }
  };
}
